import { render, staticRenderFns } from "./SvgLogout.vue?vue&type=template&id=11ddac88&scoped=true&"
import script from "./SvgLogout.vue?vue&type=script&lang=js&"
export * from "./SvgLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ddac88",
  null
  
)

export default component.exports